export default __webpack_public_path__ + "static/media/11.f70fff4e.jpg";